export default class PushNotificationActionCreator {
    run() {
        const action = this.create();
        action.run();
    }
}
